export default __webpack_public_path__ + "static/leatherette-eae45903bd6cd25461b95a9ee199ecd4.png";